import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { QuickListDataSourceFactory } from '@skylab-angular-shared/business';
import { TranslatePipe } from '@skylab-angular-shared/pipes';
import { ButtonComponent, DialogContentComponentBase, DialogContentComponentIns, DialogHeaderComponentIns, DialogInsService, DialogState, DynamicListDirective, FocusByDirective, FormContainerComponent, QuickListInsComponent } from '@skylab-angular-shared/ui';
import { CacheableQuickListDataSourceBase, ClientQLCollectionItem, ClientQLCollectionQuery, QuickListDataSourceFactoryBase, QuickListFilterMethod, quickListFilterMethod } from '@skylab-shared/business';
import { ClientQuickListItemComponent } from '../../quick-list/quick-list-client-item/quick-list-client-item.component';

type ClientFilterViewModel = {
    clientFilter: QuickListFilterMethod<ClientQLCollectionItem>;
    client: {
        value: Partial<ClientQLCollectionItem>;
    };
    onClientFavouriteSwitch: () => void;
};

type ClientFilterDialogData = Partial<ClientQLCollectionItem>;

@Component({
    selector: 'skl-client-filter-dialog',
    templateUrl: './client-filter-dialog.component.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [DialogContentComponentIns, DialogHeaderComponentIns, FormContainerComponent, FocusByDirective, QuickListInsComponent, FormsModule, DynamicListDirective, ClientQuickListItemComponent, ButtonComponent, TranslatePipe]
})
export class ClientFilterDialogComponent extends DialogContentComponentBase<ClientFilterViewModel, ClientFilterDialogData> {
    private clientDataSource!: CacheableQuickListDataSourceBase<ClientQLCollectionQuery, ClientQLCollectionItem>;

    public constructor(
        @Inject(QuickListDataSourceFactory) private readonly quickListDataSourceFactory: QuickListDataSourceFactoryBase,
        dialogService: DialogInsService
    ) {
        super(dialogService);
    }

    protected override getInitialState(): ClientFilterViewModel {
        let client: Partial<ClientQLCollectionItem> = this.data || null;
        this.clientDataSource = this.quickListDataSourceFactory.createCacheable(ClientQLCollectionQuery);

        return {
            ...super.getInitialState(),
            client: {
                get value(): Partial<ClientQLCollectionItem> {
                    return client;
                },
                set value(value: Partial<ClientQLCollectionItem>) {
                    client = value;
                }
            },
            clientFilter: quickListFilterMethod(this.clientDataSource),
            onClientFavouriteSwitch: () => {
                this.clientDataSource.clearCache();
            }
        };
    }

    public chooseItem(): void {
        if (!this.viewModel.client.value) return;
        this.dialogService.close({
            state: DialogState.Confirm,
            data: this.viewModel.client.value
        });
    }

    public override ngOnDestroy(): void {
        super.ngOnDestroy();
        this.clientDataSource?.dispose();
    }
}
